import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { isActiveMemberForSeason } from '../utils/memberStatus';
import InactiveMemberNotice from './InactiveMemberNotice';

const ActiveMemberRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { t } = useLanguage();

  if (loading) {
    return <div style={{ padding: '4rem', textAlign: 'center' }}>{t('membership.loading')}</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!isActiveMemberForSeason(user)) {
    return (
      <div className="container" style={{ padding: '2rem 1rem' }}>
        <InactiveMemberNotice />
      </div>
    );
  }

  return children;
};

export default ActiveMemberRoute;
